import AppDialogManagerService from '@/components/dialogs/AppDialogManager/app-dialog-manager-service';
import { BUILDER_VERSION_HISTORY_ROUTE_NAME, BUILDER_TASK_LOG_INNER_PAGE } from '@/router/router.const.js';
import { APP_CONFIRMATION_DIALOG_RESPONSES } from '@/components/dialogs/AppDialogs/app-confirmation-dialog.const.js';

const closeLeftSideDrawerSpecialRouterView = (router) =>
	router.push({ name: 'Feature', params: { ...router.currentRoute.params, versionId: null, taskLogId: null } });

const getWorkflowDraftVersionNumber = (workflow) => (Math.max(...workflow.versions.map((version) => version.version)) || 0) + 1;

const getRoutePrefix = ({ isVersionHistoryOpen, isViewingTaskLog }) =>
	isVersionHistoryOpen ? BUILDER_VERSION_HISTORY_ROUTE_NAME : isViewingTaskLog ? BUILDER_TASK_LOG_INNER_PAGE : '';

const restoreVersion = async ({
	router,
	version,
	workflowId,
	hasConfiguration,
	navigateToVersionAfterCreation = true,
	restoreSelectedWorkflowSpecificVersionAsDraft,
}) => {
	const dialogProps = {
		title: 'Copy configurations from previous version?',
		description:
			'Agreeing will copy the configurations from the previous version to the new version. Otherwise, the configurations will be cleared.',
		softNote: 'Notice: Reverting to a previous version of a feature that has a setup may require users to re-do the setup.',
		yesText: 'Copy',
		noText: 'Clear',
		isDanger: false,
	};
	const res = hasConfiguration ? await AppDialogManagerService.openConfirmationDialog(dialogProps) : APP_CONFIRMATION_DIALOG_RESPONSES.YES;
	const copyConfigurationsResponseFromVersion = res === APP_CONFIRMATION_DIALOG_RESPONSES.YES;
	const workflow = await restoreSelectedWorkflowSpecificVersionAsDraft({
		version,
		workflowId,
		copyConfigurationsResponseFromVersion,
	});
	const draftVersionId = workflow.current_draft.id;
	const isAlreadyViewingDraftVersion =
		router.currentRoute.params.versionId === draftVersionId && router.currentRoute.name === BUILDER_VERSION_HISTORY_ROUTE_NAME;
	if (navigateToVersionAfterCreation && !isAlreadyViewingDraftVersion) {
		router.push({ name: BUILDER_VERSION_HISTORY_ROUTE_NAME, params: { ...router.currentRoute.params, versionId: draftVersionId } });
	}
};

const WorkflowVersionService = {
	getRoutePrefix,
	restoreVersion,
	getWorkflowDraftVersionNumber,
	closeLeftSideDrawerSpecialRouterView,
};

export default WorkflowVersionService;
